import styled from 'styled-components';

const forgotPasswordStyledComponent = styled.div``;

export default forgotPasswordStyledComponent;
